import React, { Component } from 'react'
import { Link } from 'gatsby'
import * as styles from './footer.module.css'

export default class Footer extends Component {

  render() {
    const title = this.props.title
    return (
      <footer>
        <div className={styles.site_footer}>
          <div><Link to={`/profile/`}>Profile</Link></div>
          <div>|</div>
          <div><a href='https://docs.google.com/forms/d/e/1FAIpQLSfYvPfNd2_hmsqOzLNIxmxAIe-6S1-Gjo0jwQuncLhb4RPbwQ/viewform' target='_blank' rel='noreferrer'>Contact</a></div>
          <div>|</div>
          <div><Link to={`/privacy/`}>Privacy Policy</Link></div>
        </div>
        <h3>© 2021 - 2025 {title}</h3>
      </footer>
    )
  }
}